import Vue from 'vue';
import axiosInstance from '../services/axiosInstance';
import { envUrls } from './env';

// envUrls.collabService = 'http://localhost:6076/collabs/';
export default class CollaborationService {
  async addTag(payload) {
    return await axiosInstance
      .post(`${envUrls.collabService}tags/add`, payload)
      .then((response) => {
        return response.data;
      })
      .catch((err) => console.log('Error', '=>', err));
  }

  async removeTag(payload) {
    return await axiosInstance
      .post(`${envUrls.collabService}tags/remove`, payload)
      .then((response) => {
        return response.data;
      })
      .catch((err) => console.log('Error', '=>', err));
  }

  async addComment(payload) {
    return await axiosInstance
      .post(`${envUrls.collabService}comments/add`, payload)
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async getComments(payload) {
    return await axiosInstance
      .get(`${envUrls.collabService}comments/get_comments/${payload}`)
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async getCommentCountsByScan(payload) {
    return await axiosInstance
      .post(`${envUrls.collabService}comments/get_counts_by_scan`, payload)
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async getScanComments(id) {
    return await axiosInstance
      .get(`${envUrls.collabService}comments/scans/${id}`)
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async shareScan(payload) {
    return await axiosInstance
      .post(`${envUrls.collabService}share/scan`, payload)
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }
  async sendFeedback(payload) {
    return await axiosInstance
      .post(`${envUrls.collabService}feedback`, payload)
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async deleteAllCommentsByScan(payload) {
    return await axiosInstance
      .delete(`${envUrls.collabService}comments/delete_by_scan/${payload}`)
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async deleteComments(payload) {
    return await axiosInstance
      .post(`${envUrls.collabService}comments/delete`, payload)
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }

  async flagCommentRemoved(payload) {
    return await axiosInstance
      .post(`${envUrls.collabService}comments/flag/${payload}`)
      .then((response) => response.data)
      .catch((err) => console.log(err));
  }
}
